export default __webpack_public_path__ + "static/media/CL04.b2429462.mp3";